import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于木瓜漫画',
            description: '木瓜漫画品牌介绍、口碑评价与联系方式',
            url: 'https://www.muguamanhua.com/about',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.muguamanhua.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.muguamanhua.com/about' },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '木瓜漫画',
            url: 'https://www.muguamanhua.com',
            description: '海量正版漫画免费在线阅读平台',
            foundingDate: '2020',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '400-888-6666',
              contactType: 'customer service',
              email: 'contact@muguamanhua.com',
            },
            address: {
              '@type': 'PostalAddress',
              streetAddress: '朝阳区漫画大厦88号',
              addressLocality: '北京',
              addressRegion: '北京',
              postalCode: '100000',
              addressCountry: 'CN',
            },
          }),
        }}
      />

      <Breadcrumb
        items={[
          { label: '首页', path: '/' },
          { label: '关于我们' },
        ]}
      />

      {/* Hero */}
      <section className="relative w-full h-[320px] md:h-[380px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20elegant%20abstract%20background%20with%20soft%20coral%20and%20peach%20watercolor%20washes%2C%20gentle%20gradients%2C%20Japanese%20paper%20texture%2C%20minimal%20and%20refined%2C%20light%20cream%20base%20with%20delicate%20warm%20touches&width=1800&height=600&seq=about-hero-bg-03&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/25"></div>
        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
          <h1 className="text-3xl md:text-4xl font-bold text-background-50 font-heading mb-3">关于木瓜漫画</h1>
          <p className="text-sm md:text-base text-background-200 max-w-xl">
            致力于为广大漫画爱好者提供海量正版、完全免费的漫画阅读体验
          </p>
        </div>
      </section>

      {/* Brand Introduction */}
      <section className="py-12 md:py-16 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-6 text-center">品牌介绍</h2>

          <div className="space-y-8 text-sm text-foreground-700 leading-relaxed">
            <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
              <h3 className="text-base font-semibold text-foreground-950 font-heading mb-3">
                <span className="w-5 h-5 inline-flex items-center justify-center text-primary-500 mr-2">
                  <i className="ri-book-open-line"></i>
                </span>
                我们的故事
              </h3>
              <p>
                木瓜漫画创立于2020年，由一群热爱漫画的年轻人共同打造。我们深知漫画迷对优质内容的渴望，
                因此致力于构建一个<strong>海量正版漫画免费在线阅读平台</strong>，让每一位漫画爱好者都能随时随地享受阅读的乐趣。
              </p>
              <p className="mt-3">
                经过多年的发展，木瓜漫画已累计收录超过<strong>10000部</strong>正版漫画作品，涵盖热血、恋爱、悬疑、
                搞笑、奇幻、科幻、冒险、校园等多种类型，总章节数超过<strong>50万话</strong>，
                累计服务活跃读者超过<strong>500万人</strong>。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                <h3 className="text-base font-semibold text-foreground-950 font-heading mb-3">
                  <span className="w-5 h-5 inline-flex items-center justify-center text-accent-500 mr-2">
                    <i className="ri-shield-check-line"></i>
                  </span>
                  正版保证
                </h3>
                <p>
                  我们与国内多家知名漫画出版社和原创漫画平台建立了深度合作关系，
                  所有上架的漫画作品均获得<strong>正版授权</strong>。我们坚决维护创作者的权益，
                  为漫画产业的健康发展贡献力量。
                </p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                <h3 className="text-base font-semibold text-foreground-950 font-heading mb-3">
                  <span className="w-5 h-5 inline-flex items-center justify-center text-secondary-500 mr-2">
                    <i className="ri-device-line"></i>
                  </span>
                  极致体验
                </h3>
                <p>
                  木瓜漫画采用先进的阅读引擎，支持<strong>电脑、平板、手机</strong>等多设备无缝切换。
                  清爽的界面设计、流畅的翻页体验、智能的推荐算法，
                  让每一次阅读都成为一种享受。
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
              {[
                { value: '2020年', label: '创立年份', icon: 'ri-calendar-line' },
                { value: '10000+', label: '正版漫画', icon: 'ri-book-2-line' },
                { value: '500万+', label: '活跃读者', icon: 'ri-user-heart-line' },
              ].map((item) => (
                <div key={item.label} className="bg-accent-50 rounded-lg p-6 border border-accent-200/50">
                  <span className="w-8 h-8 flex items-center justify-center mx-auto text-lg text-accent-500 mb-2">
                    <i className={item.icon}></i>
                  </span>
                  <div className="text-xl font-bold text-accent-700 font-heading">{item.value}</div>
                  <div className="text-xs text-foreground-600 mt-1">{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Reputation */}
      <section className="py-12 md:py-16 bg-background-100">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-6 text-center">口碑评价</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              {
                name: '漫画迷小明',
                rating: 5,
                comment: '木瓜漫画真的太好用了！界面清爽没有广告，更新速度也很快，最重要的是完全免费，已经推荐给身边所有喜欢看漫画的朋友了！',
                date: '2026-07-15',
              },
              {
                name: '二次元少女',
                rating: 5,
                comment: '作为一个资深漫画迷，木瓜漫画是我用过最棒的漫画阅读平台。分类很全，画质高清，阅读体验一流。强烈推荐！',
                date: '2026-07-20',
              },
              {
                name: '夜深人静',
                rating: 5,
                comment: '自从发现了木瓜漫画，我的通勤时间都变得有趣了。悬疑漫画的质量尤其高，情节紧凑让人欲罢不能。给开发团队点赞！',
                date: '2026-08-01',
              },
              {
                name: '热血少年阿杰',
                rating: 4,
                comment: '热血漫画的收藏很全，很多小众热血的漫画也能找到。希望以后能增加更多互动功能，比如评论区和讨论组。',
                date: '2026-08-03',
              },
              {
                name: '樱花飘落',
                rating: 5,
                comment: '恋爱漫画的画风都超级好看！木瓜漫画的推荐算法也很准，总能给我推荐到喜欢的作品。每天睡前必刷！',
                date: '2026-08-05',
              },
              {
                name: '程序员老王',
                rating: 5,
                comment: '不管是网页版还是APP，体验都非常流畅。加载速度快，翻页丝滑，离线下载功能也很实用。木瓜漫画，永远的神！',
                date: '2026-08-08',
              },
            ].map((review, index) => (
              <div key={index} className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                <div className="flex items-center gap-1 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className={`w-3 h-3 flex items-center justify-center text-xs ${i < review.rating ? 'text-secondary-500' : 'text-foreground-300'}`}>
                      <i className={i < review.rating ? 'ri-star-fill' : 'ri-star-line'}></i>
                    </span>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  &ldquo;{review.comment}&rdquo;
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="font-medium text-foreground-800">{review.name}</span>
                  <span>{review.date}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-12 md:py-16 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-6 text-center">联系我们</h2>
          <p className="text-sm text-foreground-500 text-center mb-8 max-w-xl mx-auto">
            如果您有任何问题、建议或合作意向，欢迎通过以下方式与我们取得联系，
            我们会在第一时间回复您。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
            {[
              { icon: 'ri-mail-line', title: '电子邮箱', content: 'contact@muguamanhua.com', sub: '商务合作 / 媒体联系', bg: 'bg-primary-50' },
              { icon: 'ri-phone-line', title: '客服电话', content: '400-888-6666', sub: '工作时间: 9:00 - 18:00', bg: 'bg-accent-50' },
              { icon: 'ri-map-pin-line', title: '公司地址', content: '北京市朝阳区漫画大厦88号', sub: '欢迎来访（请提前预约）', bg: 'bg-secondary-50' },
            ].map((item) => (
              <div key={item.title} className={`${item.bg} rounded-lg p-5 border border-background-200/70 text-center`}>
                <span className="w-10 h-10 flex items-center justify-center mx-auto text-xl text-foreground-800 mb-3">
                  <i className={item.icon}></i>
                </span>
                <h3 className="text-sm font-semibold text-foreground-950 font-heading mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-700 font-medium mb-1">{item.content}</p>
                <p className="text-xs text-foreground-500">{item.sub}</p>
              </div>
            ))}
          </div>

          {/* Map */}
          <div className="rounded-lg overflow-hidden border border-background-200/70">
            <iframe
              title="木瓜漫画公司位置"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.2399!2d116.4551!3d39.9219!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35f05137c9d5e5d3%3A0x9c0e4d8b88a3a9f!2sChaoyang%2C%20Beijing!5e0!3m2!1szh-CN!2scn!4v1690000000000"
              width="100%"
              height="320"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </>
  );
}